import React, { useState } from "react";
import Breadcrumbs from "../../Breadcrumbs";

import Select from "react-select";

const fileTypeOptions = [
  { value: "XLSX", label: "XLSX" },
  { value: "CSV", label: "CSV" },
  { value: "PDF", label: "PDF" },
];

const socialMediaOptions = [
  {
    value: "instagram",
    label: (
      <div className="d-flex align-items-center gap-2">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
          width="18"
        />
        Instagram
      </div>
    ),
  },
  {
    value: "youtube",
    label: (
      <div className="d-flex align-items-center gap-2">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/0/09/YouTube_full-color_icon_%282017%29.svg"
          width="18"
        />
        YouTube
      </div>
    ),
  },
  {
    value: "tiktok",
    label: (
      <div className="d-flex align-items-center gap-2">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Tiktok_icon.svg/640px-Tiktok_icon.svg.png"
          width="18"
        />
        TikTok
      </div>
    ),
  },
];

const InfluencerExport = () => {
  const [formData, setFormData] = useState({
    fileType: [],
    socialMedia: [],
    profiles: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value?.target ? value.target.value : value,
    }));
  };
  const handleSubmit = () => {
    console.log({
      fileType: formData.fileType,
      socialMedia: formData.socialMedia,
      profiles: formData.profiles,
    });
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Export List</h4>
          <div className="page-title-right">
            <Breadcrumbs />
          </div>
        </div>
      </div>

      <div className="col-lg-12">
        <div className="card">
          <div className="row p-4 bg-light justify-content-center">
            <div className="col-lg-10">
              <h2 className="fw-semibold mb-1">Bulk Export</h2>
              <p className="text-muted mb-4">Add upto 200 profiles at once.</p>

              {/* SELECTS */}
              <div className="row g-3 mb-3">
                <div className="col-md-6">
                  <Select
                    placeholder="Select File Type"
                    options={fileTypeOptions}
                    value={formData.fileType}
                    onChange={(selected) => handleChange("fileType", selected)}
                  />
                </div>

                <div className="col-md-6">
                  <Select
                    placeholder="Select Social Media"
                    options={socialMediaOptions}
                    value={formData.socialMedia}
                    onChange={(selected) =>
                      handleChange("socialMedia", selected)
                    }
                  />
                </div>
              </div>

              {/* TEXTAREA */}
              <div className="mb-4">
                <textarea
                  className="form-control bg-white border rounded-3 p-4"
                  rows="7"
                  placeholder="Enter profiles (one per line)"
                  value={formData.profiles}
                  onChange={(e) => handleChange("profiles", e)}
                />
              </div>

              {/* SUBMIT */}
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-danger px-5 py-3 rounded-3 fw-semibold"
                  onClick={handleSubmit}
                >
                  EXPORT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfluencerExport;
